var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderButton)?_c('CButton',{staticClass:"back-to-top print:tw-hidden",class:{ active: _vm.showBtt },attrs:{"aria-label":_vm.$t('to top')},on:{"click":_vm.backToTop}},[_c('fa',{attrs:{"icon":_vm.icons.chevronUp}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }